import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';

export const useNavigationGuard = ({
	when,
	onTrigger,
}: {
	when: boolean;
	onTrigger: (nextLocation: string) => void;
}) => {
	const history = useHistory();
	const unblockRef = useRef<() => void>();

	useEffect(() => {
		if (!when) return;

		unblockRef.current = history.block(tx => {
			onTrigger(tx.pathname + tx.search);
			return false; // cancela a navegação
		});

		return () => {
			if (unblockRef.current) {
				unblockRef.current();
			}
		};
	}, [when, onTrigger, history]);
};
